<ngx-datatable
  *ngIf="SHOW_TABLE"
  class="material File-table"
  columnMode="force"
  [headerHeight]="40"
  [rowHeight]="50"
  [messages]="{ emptyMessage: '' }"
  [footerHeight]="0"
  [reorderable]="false"
  [rows]="items"
  [rowClass]="getRowClass"
  [columns]="columns"
  (activate)="rowSelected($event)"
>
  <ngx-datatable-column name="title">
    <ng-template let-column="column" ngx-datatable-header-template> Namn </ng-template>
    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
      <mat-icon>{{ row.getIconString() }}</mat-icon
      >{{ row.title }}
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="mime">
    <ng-template let-column="column" ngx-datatable-header-template> Typ </ng-template>
    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
      {{ value }}
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="size">
    <ng-template let-column="column" ngx-datatable-header-template> Storlek </ng-template>
    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
      {{ value }}
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>
